<template>
	<div>
		<page-header :title="title"></page-header>
		<div class="casa-trabalhador-banner">
			<img
				:src="bannerDisplaySrc"
				alt="Casa do Trabalhador"
				@error="onBannerImgError"
			/>
		</div>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="data"> Data</label>
						<div class="col-sm-3">
							<flat-pickr class="col-xs-10 col-sm-3 form-control" v-model="form.not_data" :config="config"
								placeholder="Data" name="date"></flat-pickr>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Texto</label>
						<div class="col-sm-9">
							<editor v-model="form.not_texto" style="height: 280px">
								<editor-tool :name="'formatting'"></editor-tool>
								<editor-tool :name="'bold'"></editor-tool>
								<editor-tool :name="'italic'"></editor-tool>
								<editor-tool :name="'underline'"></editor-tool>
								<editor-tool :name="'fontSize'"></editor-tool>
								<editor-tool :name="'foreColor'"></editor-tool>
								<editor-tool :name="'undo'"></editor-tool>
								<editor-tool :name="'redo'"></editor-tool>
								<editor-tool :name="'viewHtml'"></editor-tool>
								<editor-tool :name="'justifyLeft'"></editor-tool>
								<editor-tool :name="'justifyCenter'"></editor-tool>
								<editor-tool :name="'justifyRight'"></editor-tool>
								<editor-tool :name="'justifyFull'"></editor-tool>
								<editor-tool :name="'cleanFormatting'"></editor-tool>
								<editor-tool :name="'insertUnorderedList'"></editor-tool>
								<editor-tool :name="'insertOrderedList'"></editor-tool>
								<editor-tool :name="'indent'"></editor-tool>
								<editor-tool :name="'outdent'"></editor-tool>
								<editor-tool :name="'createLink'"></editor-tool>
								<editor-tool :name="'unlink'"></editor-tool>
								<editor-tool :name="'print'"></editor-tool>
							</editor>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right"></label>
						<div class="col-sm-5">
							<items-edit v-if="allImages.length" :files="allImages" url="/v1/noticias/upload" :capa="true" id="fot_not_cod" :isDrag="true" urlSort="/v1/noticias/order/" idSort="fot_not_cod"></items-edit>
							<file-upload ref="fupload" :url="`/v1/noticias/upload`" :id="null" :label="'PNG, JPG, GIF até 10 MB'"  width="800" :saveOrder="true"></file-upload>

						</div>
					</div>
					<input-form-text textInput="Créditos"  v-model="form.not_creditos"
						:value="form.not_creditos"></input-form-text>
					<div class="form-group">
						<select-form v-model="form.not_ativa" :value="form.not_ativa" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import 'clockpicker/dist/jquery-clockpicker.min'
import 'clockpicker/dist/bootstrap-clockpicker.min.css'
import '@progress/kendo-ui'
import '@progress/kendo-ui/css/web/kendo.default-v2.min.css'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'
import '@progress/kendo-ui/js/messages/kendo.messages.pt-BR'
import { Editor, EditorTool, EditorInstaller } from '@progress/kendo-editor-vue-wrapper'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

moment.locale('pt-BR')
// eslint-disable-next-line no-undef
kendo.culture('pt-BR')
Vue.use(EditorInstaller)

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		flatPickr,
		Editor,
		EditorTool,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		]),
		bannerDisplaySrc() {
			if (this.bannerPendingSrc) {
				return this.bannerPendingSrc
			}
			const saved = this.capaUrlFromList(this.allImages)
			if (saved) {
				return saved
			}
			return this.bannerPadraoUrl
		}
	},
	data() {
		return {
			title: 'Casa do Trabalhador',
			bannerPadraoUrl: require('@/assets/images/banner-casa-trabalhador.jpg'),
			bannerPendingSrc: null,
			form: {
				not_data: '',
				casa_trabalhador: true,
				not_texto: '',
				not_creditos: '',
				not_ativa: '1'
			},
			isActive: false,
			isActiveBtn: false,
			config: {
				wrap: true,
				altInput: true,
				altFormat: 'd \\de F \\de Y',
				dateFormat: 'Y-m-d',
				locale: Portuguese
			},
			allImages: [],
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		capaUrlFromList(list) {
			if (!list || !list.length) {
				return null
			}
			const capa = list.find(i => i.capa == 1 || i.capa === true)
			if (capa && capa.images) {
				return capa.images
			}
			const first = list[0]
			return first && first.images ? first.images : null
		},
		syncBannerPending() {
			const fu = this.$refs.fupload
			if (!fu || !fu.temporaryFiles || !fu.temporaryFiles.length) {
				this.bannerPendingSrc = null
				return
			}
			const img = fu.temporaryFiles.find(t => t.type === 'image')
			this.bannerPendingSrc = img && img.url ? img.url : null
		},
		onBannerImgError(e) {
			const t = e.target
			if (!t || t.dataset.bannerFallback === '1') {
				return
			}
			t.dataset.bannerFallback = '1'
			t.src = this.bannerPadraoUrl
		},
		async injectDefaultBannerIfEmpty() {
			const fu = this.$refs.fupload
			if (!fu || (fu.files && fu.files.length > 0)) {
				return
			}
			try {
				const res = await fetch(this.bannerPadraoUrl)
				if (!res.ok) {
					return
				}
				const blob = await res.blob()
				const file = new File([blob], 'banner-casa-trabalhador.jpg', {
					type: blob.type || 'image/jpeg',
				})
				fu.files.push(file)
				fu.temporaryFiles.push({
					type: 'image',
					url: URL.createObjectURL(blob),
					status: 'pending',
					percent: 0,
					name: file.name,
				})
				this.syncBannerPending()
			} catch {
				// optional default banner; ignore fetch/decode failures
			}
		},
		async ensureCapaSeNenhuma(notCod) {
			if (!notCod) {
				return
			}
			const images = await req(`/v1/noticias/images/${notCod}`).catch(() => null)
			if (!images || !images.length) {
				return
			}
			const temCapa = images.some(i => i.capa == 1 || i.capa === true)
			if (temCapa) {
				return
			}
			const first = images[0]
			if (!first || !first.fot_not_cod) {
				return
			}
			await req(`/v1/noticias/upload/${first.fot_not_cod}`, 'put', {
				fot_not_cod: first.fot_not_cod,
				noticias_not_cod: notCod,
			}).catch(() => {})
		},
		bodyPayload() {
			return {
				...this.form,
				casa_trabalhador: true
			}
		},
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.bodyPayload()
			if (this.$route.params.id) {
				const resp = await req(`/v1/noticias/${this.$route.params.id}`, 'put', body).catch(response => {
					'error: ' + response
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/casa-trabalhador')
			} else {
				const resp = await req('/v1/noticias', 'post', body).catch(response => {
					'error: ' + response
					erro()
					return null
				})
				this.isActive = false
				if (!resp || !resp.not_cod) {
					this.isActiveBtn = false
					return
				}
				await this.injectDefaultBannerIfEmpty()
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				if (m) {
					await m.uploadAll(resp)
				}
				await this.ensureCapaSeNenhuma(resp.not_cod)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/casa-trabalhador')
			}
			this.isActiveBtn = false
		},
		async getDados() {
			const resp = await req(`/v1/noticias/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			if (resp.not_fonte !== 'CASA DO TRABALHADOR') {
				erro()
				this.$router.push('/site/casa-trabalhador')
				return
			}
			this.form.not_data = resp.not_data
			this.form.not_texto = resp.not_texto
			this.form.not_creditos = resp.not_creditos
			this.form.not_ativa = resp.not_ativa
			const images = await req(`/v1/noticias/images/${this.$route.params.id}`).catch(response => {
				'error: ' + response
				erro()
			})
			this.allImages = images
			this.isActive = false

		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		// eslint-disable-next-line no-undef
		$('.hora').clockpicker({
			placement: 'bottom',
			align: 'left',
			autoclose: true,
			'default': 'now'
		}).on('change', e => {
			this.form.timenot = e.target.value
		})

		this.form.not_data = moment(new Date()).format('YYYY-MM-DD H:m:s')

		this.verifPermissao()

		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}

		this.$nextTick(() => {
			this.syncBannerPending()
			const fu = this.$refs.fupload
			if (fu) {
				this.$watch(
					() => (fu.temporaryFiles || []).map(f => `${f.url || ''}|${f.status || ''}|${f.type || ''}`).join(','),
					() => {
						this.syncBannerPending()
					},
					{ immediate: true }
				)
			}
		})
	}
}
</script>

<style lang="scss">
.casa-trabalhador-banner {
	max-width: 280px;
	min-height: 72px;
	margin: 0 auto 12px;
	text-align: center;
	img {
		display: inline-block;
		max-width: 100%;
		max-height: 100px;
		min-height: 48px;
		width: auto;
		height: auto;
		object-fit: contain;
		border-radius: 6px;
		vertical-align: middle;
	}
}
</style>
